import { StyleSheet } from 'aphrodite/no-important';
import { media, palette } from 'util/style-helpers';

export const style: any = () => {
  return StyleSheet.create({
    btn: {
      background:
        'transparent linear-gradient(180deg, #E60012 0%, #98000C 100%, #730009 100%) 0% 0% no-repeat padding-box',
      border: '0',
      height: '44px',
      borderRadius: '5px',
      color: '#fff',
      fontWeight: 'bold',

      [media.desktop]: {
        border: `1px solid ${palette.red}`,
        background: 'transparent',
        color: palette.red,
        height: '34px',
        ':hover': {
          background: palette.red,
          color: palette.white,
        },
      },
    },
  });
};
